import { CourseModalProvider } from "./course-modal-provider/CourseModalProvider";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};
